var _path, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrouping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7C7.44772 7 7 7.44771 7 8V12.6667C7 13.219 7.44771 13.6667 8 13.6667H10.3333V16C10.3333 16.5523 10.781 17 11.3333 17H16C16.5523 17 17 16.5523 17 16V11.3333C17 10.781 16.5523 10.3333 16 10.3333H13.6667V8C13.6667 7.44772 13.219 7 12.6667 7H8Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 2.75,
    width: 18.5,
    height: 18.5,
    rx: 1.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 1,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 20,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrouping);
export default __webpack_public_path__ + "static/media/grouping.7a193585.svg";
export { ForwardRef as ReactComponent };